//Built-in libraries

//Third party libraries

import Button from '@/components/UI/Button';
//Custom components
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import HookMaskedInput from '@/components/UI/HookForm/Form/MaskedInput';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

import { useFormContext } from 'react-hook-form';
import { HookCheckbox } from '@/components/UI/HookForm/Form/Checkbox';
import { HookFileInput } from '@/components/UI/HookForm/Form/File';
//Assets and Miscellaneous
import { HookRadioGroup } from '@/components/UI/HookForm/Form/RadioGroup';
import { HookSelect } from '@/components/UI/HookForm/Form/Select';
import { HookTextarea } from '@/components/UI/HookForm/Form/TextArea';
import { States } from '../../../../../../constants';
import { legislativeDistrict } from './constant';

//Component Begin

export default function Application() {
  const { setCurrentStep } = useApplicationFormContext();
  const { watch } = useFormContext();
  const { isCoOwner, hasLongTermLease, doesNotOwn } = watch('step1.section3');

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>Application</h3>
        <section className='space-y-4'>
          <h4 className='font-bold'>Project Information</h4>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput
              customClassName='col-span-6 sm:col-span-2'
              id='name'
              label='Name of Bond Bill'
              name='step1.section1.bondBill'
              type='text'
            />
            <HookInput
              customClassName='col-span-6 sm:col-span-2'
              label='Project Title'
              name='step1.section1.projectTitle'
              type='text'
              id='project-title'
            />
            <HookSelect
              customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
              id='legislative-district'
              label='Legislative District'
              name='step1.section1.legislativeDistrict'
              options={legislativeDistrict.map((district: any) => ({
                label: district,
                value: district,
              }))}
            />
            <HookMaskedInput
              customClassName='col-span-6 sm:col-span-2'
              label='Chapter Number'
              name='step1.section1.chapterNumber'
              id='chapterNumber'
              maskedComponent='numeric'
            />
            <HookInput
              customClassName='col-span-6 sm:col-span-2'
              label='Year Authorized'
              name='step1.section1.authorizedYear'
              type='date'
              id='authorized-year'
            />
            <HookMaskedInput
              customClassName='col-span-6 sm:col-span-2'
              label='DGS item Number'
              name='step1.section1.dgsItemNumber'
              id='dgs-item-number'
              maskedComponent='numeric'
            />
            <HookInput customClassName='col-span-6' label='Street Address' name='step1.section1.streetAddress' type='text' id='address' />
            <HookInput customClassName='col-span-6 sm:col-span-2' label='City' name='step1.section1.city' type='text' id='city' />
            <HookSelect
              customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
              id='state'
              label='State / Province'
              name='step1.section1.state'
              options={States.map((state: any) => ({
                label: state.name,
                value: state.name,
              }))}
              disabled
            />
            <HookMaskedInput
              customClassName='col-span-6 sm:col-span-2'
              label='Zip/Postal Code'
              name='step1.section1.zipCode'
              id='zipCode'
              maskedComponent='zipCode'
            />
          </div>
        </section>
        <section className='space-y-4'>
          <h4 className='font-bold'>Grantee Information</h4>
          <div className='grid grid-cols-6 gap-6'>
            <HookInput
              customClassName='col-span-6'
              label='Legal Name of Grantee Organization'
              name='step1.section2.granteeOrganization'
              type='text'
              id='grantee-organization'
            />
            <HookInput customClassName='col-span-6 ' label='Street Address' name='step1.section2.streetAddress' type='text' id='address' />
            <HookInput customClassName='col-span-6 sm:col-span-2' label='City' name='step1.section2.city' type='text' id='city' />
            <HookSelect
              customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
              id='state'
              label='State / Province'
              name='step1.section2.state'
              options={States.map((state: any) => ({
                label: state.name,
                value: state.name,
              }))}
            />
            <HookMaskedInput
              customClassName='col-span-6 sm:col-span-2'
              label='Zip/Postal Code'
              name='step1.section2.zipCode'
              id='zipCode'
              maskedComponent='zipCode'
            />
            <HookMaskedInput
              customClassName='col-span-6 sm:col-span-2'
              label='Grant Amount'
              name='step1.section2.grantAmount'
              id='grant-amount'
              maskedComponent='currency'
            />
            <HookMaskedInput
              customClassName='col-span-6 sm:col-span-2'
              label='Match Amount'
              name='step1.section2.matchAmount'
              id='match-amount'
              maskedComponent='currency'
            />
          </div>
        </section>
        <section className='space-y-4'>
          <h4 className='font-bold'>Grantee Interest in real property to be improved with Grant</h4>
          <div className='space-y-3 grid grid-cols-6 gap-x-6'>
            <HookCheckbox
              className='col-span-6 md:col-span-6'
              label='Grantee organization is the sole owner'
              name='step1.section3.isSoloOwner'
              id='is-solo-owner'
            />
            <HookCheckbox
              className='col-span-6 md:col-span-6'
              label='Grantee organization is a co-owner'
              name='step1.section3.isCoOwner'
              id='is-co-owner'
            />
            {isCoOwner && (
              <HookInput
                customClassName='col-span-3 sm:col-span-2'
                id='co-owner-name'
                label='Co-owner Name'
                name='step1.section3.coOwnerName'
                type='text'
              />
            )}
            <HookCheckbox
              className='col-span-6 md:col-span-6'
              label='Grantee does not own the property but has a long-term lease'
              name='step1.section3.hasLongTermLease'
              id='has-long-term-lease'
            />
            {hasLongTermLease && (
              <>
                <HookMaskedInput
                  customClassName='col-span-3 sm:col-span-1'
                  id='lease-term'
                  label='Lease Term'
                  name='step1.section3.leaseTerm'
                  maskedComponent='numeric'
                />
                <div className='col-span-3 sm:col-span-5'>
                  <HookFileInput name='step1.section3.selectedFiles' label='Provide a copy of the lease (in pdf)' id='selectedFile' />
                </div>
              </>
            )}
            <HookCheckbox
              className='col-span-6 md:col-span-6'
              label='Grantee does not own or lease the project property'
              name='step1.section3.doesNotOwn'
              id='does-not-own'
            />
            {doesNotOwn && (
              <>
                <HookInput
                  customClassName='col-span-3 sm:col-span-2'
                  id='owner-name'
                  label="Owner's Name"
                  name='step1.section3.ownerName'
                  type='text'
                />
                <HookInput
                  customClassName='col-span-3 sm:col-span-2'
                  id='owner-email'
                  label="Owner's Email Address"
                  name='step1.section3.ownerEmail'
                  placeholder='myemail@example.com'
                  type='email'
                />
                <HookMaskedInput
                  customClassName='col-span-3 sm:col-span-2'
                  id='owner-phone-number'
                  label="Owner's Phone Number"
                  name='step1.section3.ownerPhoneNumber'
                  maskedComponent='phone'
                />
              </>
            )}
          </div>
        </section>
        <section className='space-y-6'>
          <h4 className='font-bold'>Estimated Project Schedule</h4>
          <div>
            <h4 className='font-medium'>Design</h4>
            <div className='grid grid-cols-6 gap-6'>
              <HookInput customClassName='col-span-2' label='Start Date' name='step1.section4.design.startDate' type='date' />
              <HookInput customClassName='col-span-2' label='Finish Date' name='step1.section4.design.finishDate' type='date' />
            </div>
          </div>
          <div>
            <h4 className='font-medium'>Construction</h4>
            <div className='grid grid-cols-6 gap-6'>
              <HookInput customClassName='col-span-2' label='Start Date' name='step1.section4.construction.startDate' type='date' />
              <HookInput customClassName='col-span-2' label='Finish Date' name='step1.section4.construction.finishDate' type='date' />
            </div>
          </div>
          <HookTextarea
            id='description'
            className='col-span-6'
            name='step1.section4.description'
            label='Project Description and Scope'
            rows={5}
            placeholder='Please tell us more about the project and scope. Include Purpose and Construction Details.'
          />
          <HookRadioGroup
            className='col-span-6 md:col-span-6'
            label='Does this project require a preservation easement to the Maryland Historical trust?'
            name='step1.section4.requirePreservationEasement'
            id='has-preservation-easement'
            options={[
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ]}
          />
          <HookRadioGroup
            className='col-span-6 md:col-span-6'
            label='You are encouraged to solicit MBE enterprises. Will this project utilize MBE enterprises to provide construction,goods and/or Services ?'
            name='step1.section4.utilizeMBEEnterprise'
            id='will-use-MBE-enterprise'
            options={[
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ]}
          />
        </section>
        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
          <Button label='Next' btnStyle='primary' type='submit' />
        </div>
      </div>
    </div>
  );
}
